<template>
  <v-container class="flex-column justify-center fill-height">
    <v-progress-circular indeterminate color="primary" :size="100" :width="10" class="mb-3" />
    <p>Redirecting...</p>
  </v-container>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useUserStore } from "../Authentication/store/userStore";

const router = useRouter();
const store = {
  authStore: useStore(),
  userStore: useUserStore(),
};

onMounted(async () => {
  await store.authStore
    .dispatch("oidcSignInCallback")
    .then((redirectPath) => {
      router.push(redirectPath);
    })
    .catch((error) => {
      // TODO handle error properly #893
      router.push("/login");
    });
});
</script>
